import { memo, useCallback, useState } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { List } from 'shared/components/list'

import { partnerFlagsTranslation } from '../../translation'

import { IPartnerFlagActionsProps } from './models'

import styles from './PartnerFlagActions.module.scss'

export const PartnerFlagActions = memo<IPartnerFlagActionsProps>(
  ({ isDisabled, isReadOnly, onAddButtonClick, onSearchKeyChange }) => {
    const [searchKey, setSearchKey] = useState('')

    const handleOnSearchKeyChange = useCallback(
      (key: string) => {
        setSearchKey(key)
        onSearchKeyChange(key)
      },
      [onSearchKeyChange]
    )

    return (
      <List.Label className={styles.panelWrapper}>
        <div className={styles.panel}>
          <RenderWhen condition={!isReadOnly}>
            <Button onClick={onAddButtonClick} disabled={isDisabled}>
              <Translation text={partnerFlagsTranslation.panel.btn.addNew} span />
            </Button>
          </RenderWhen>
          <Input
            value={searchKey}
            onChange={handleOnSearchKeyChange}
            label={<Translation text={partnerFlagsTranslation.panel.field.search} span />}
            classes={{ root: styles.search }}
          />
        </div>
      </List.Label>
    )
  }
)
